module.exports = __webpack_public_path__ + "media/images/aboutus/bg-center-bcf1baae81148502ad0bc8dba8090ecf.png";